/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 59a99c5e (Wed Sep  2 22:08:21 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface SharePlaylist
 */
export interface SharePlaylist {
  /**
   * Foreign key referencing the user (nullable if user not found).
   * @type number
   * @memberof SharePlaylist
   */
  userKey?: number
  /**
   * Email address used for the share attempt.
   * @type string
   * @memberof SharePlaylist
   */
  email: string
}

export function SharePlaylistFromJSON(json: any): SharePlaylist {
  return SharePlaylistFromJSONTyped(json, false)
}

export function SharePlaylistFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharePlaylist {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    email: json['email'],
  }
}

export function SharePlaylistToJSON(value?: SharePlaylist | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userKey: value.userKey,
    email: value.email,
  }
}
